<template>
  <div>
    <div id="captcha-element"></div>
    <div id="captcha-button"></div>
    <!-- 对话框的隐藏和显示在vuex中存放   全局控制 -->
    <van-overlay :show="$store.state.Login.loginDialog" @click="close" z-index="99999" :lock-scroll="false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <van-row>
            <!-- 关闭按钮 -->
            <van-col :span="24" class="text-r" @click="close">
              <van-icon name="cross" />
            </van-col>
            <!-- title -->
            <van-col :span="24" class="title" v-if="loginType == 'sms'">
              手机号登录
              <span>新用户登录后自动生成账号</span>
            </van-col>
            <van-col :span="24" class="titile" v-if="loginType == 'password'">
              账号密码登录
            </van-col>
            <van-col :span="24" class="titile" v-if="loginType == 'forgetPWd'">
              忘记密码
            </van-col>
            <!-- 手机号输入框 -->
            <van-col :span="22" :offset="1" class="m-t-9" v-if="loginType != 'forgetPWd'">
              <van-field
                clearable
                placeholder="请输入手机号"
                class="phone"
                style="height:2.1rem;line-height:1.8rem"
                v-model="phone"
                ref="phone"
              >
                <template
                  #left-icon
                  style="line-height:100%;margin-left:0.3rem"
                >
                  <van-icon
                    :name="phoneNew"
                    class="phoneIcon"
                  />
                </template>
              </van-field>
            </van-col>
            <!-- <van-col :span="9" :offset="1" class="m-t-10" v-if="loginType != 'forgetPWd'">
              <country-code-selector :countryCode.sync="areaCode"></country-code-selector>
            </van-col> -->
            <van-col :span="22" :offset="1" class="m-t-9" v-if="loginType == 'password'">
              <van-field
                clearable
                placeholder="请输入密码"
                class="phone"
                style="height:2.1rem;line-height:1.8rem"
                v-model="password"
                type="password"
                ref="password"
              >
                <template
                  #left-icon
                  class="m-l-03"
                  style="line-height:100%"
                >
                  <van-icon :name="passwordIcon" class="phoneIcon" />
                </template>
              </van-field>
            </van-col>
            <!-- 输入验证码  -->
            <van-col :span="13" :offset="1" class="m-t-05" v-if="loginType == 'sms'">
              <van-field
                clearable
                placeholder="请输入验证码"
                class="password"
                style="height:2.1rem;line-height:1.8rem"
                v-model="codeNumber"
                ref="codeNumber"
                maxlength="4"
              >
                <template
                  #left-icon
                  style="line-height:100%"
                  class="m-l-03"
                >
                  <van-icon
                    :name="passwordIcon"
                    class="passwordIcon"
                  />
                </template>
              </van-field>
            </van-col>
            <!-- 获取验证码按钮 -->
            <van-col :span="9" :offset="1" class="m-t-05" v-if="loginType == 'sms'">
              <van-button
                type="primary"
                class="b-r-013 f-s-5"
                style="height:2.1rem;width:85%"
                @click="getSmsClick"
                :disabled="this.wait != 60"
                >{{ wait == 60 ? "获取验证码" : "重新发送" + wait }}</van-button
              >
            </van-col>
            <van-col :span="24" class="m-t-05 f-s-6 colorRed" v-if="loginType == 'sms' && codeErr">验证码错误或无效,请重新输入</van-col>
            <!-- 忘记密码 -->
            <ForgetPwd v-if="loginType == 'forgetPWd'" @switchLogin="switchLogin" />
            <!-- 登录按钮 -->
            <van-col :span="22" :offset="1" v-if="loginType != 'forgetPWd'">
              <van-button type="info" style="width:100%;margin-top:1rem;height:2.1rem" class="f-s-7 b-r-013 xz-button-info" @click="loginXZ">进入小筑教育</van-button>
            </van-col>
            <!-- 切换为账号密码登录 -->
            <!-- <van-col :span="21" class="text-r m-t-3 f-s-6 colorHui" @click="switchLogin">
              {{loginType == 'sms' ? '账号密码登录 >' : '验证码登录 >'}}
            </van-col> -->
            <van-col :span="21" class="text-r m-t-3 f-s-6 colorHui" @click="switchLogin(3)" v-if="loginType == 'password'">
              忘记密码?
            </van-col>
          </van-row>
        </div>
      </div>
    </van-overlay>
    <toast ref="toast"></toast>
  </div>
</template>

<script>
/* eslint-disable */
import {phoneReg,pwdReg} from '@/utils/regular.js'
import { loginPwd,getVerificationCode,loginCode } from "@/model/user/userServe";
import { CacheModule } from "@/utils/commonUtils.js";
import { mutations } from "@/observable/store";
import Toast from "@/components/toast/tosatInfo";
import ForgetPwd from '@/components/login/forgetPwd'
import countryCodeSelector from "vue-country-code-selector";
const SCENEID = "1bkexcfo";
const PREFIX = "pslhy6";
export default {
  components:{
    Toast , ForgetPwd,countryCodeSelector
  },
  created(){
    let belong = this.$route.query.belong
    if(this.isNotNull(belong) && belong != this.getLocal('belong')){
      this.setLocal('belong',belong)
    }
  },
  data() {
    return {
      captcha: null,
      captchaButton: null,
      initAliyunCaptcha: false,
      areaCode:86,
      show: true,
      wait: 60, // 短信倒计时
      loginType: 'sms',  // 登录的类型   sms短信登录  password  密码登录
      phone:'', // 手机号
      password:'', // 密码
      codeNumber:'',  // 验证码
      ifCodeNumber:true,  // 是否获取验证码
      codeErr:false,  // 验证码是否有错误
      phoneNew:require('@/assets/imgs/PhoneNew.png'), // 手机icon
      passwordIcon:require('@/assets/imgs/password.png'),
      QQLoginPng:require('@/assets/imgs/login/Qq.png'),
      QQLogin:{
        appid:"101941950",
        appKey:"858be1491b7bbd566d9c9c6e8f833eee"
      },
    };
  },
  created() {
    this.handleInitCaptchaScript();
  },
  methods: {
    handleInitCaptchaScript() {
      if (this.initAliyunCaptcha) return;
      this.loadScript(
        "//o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js",
        () => {
          console.log("阿里云验证码模块.");
          this.initAliyunCaptcha = true;
          this.handleInitCaptcha();
        }
      );
    },
    async getBase64FromImageUrl(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous"; // 如果图片跨域，则需要设置这个属性
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL("image/png");
          resolve(dataURL);
        };
        img.onerror = (err) => reject(err);
        img.src = url;
      });
    },
    async handleInitCaptcha() {
      let base64Img = '';
      try {
        const logoPath = require("@/assets/imgs/logo.png"); // 获取图片路径
         base64Img = await this.getBase64FromImageUrl(logoPath);
        console.log("Base64:", base64Img);
      } catch (error) {
        console.error("获取base64图片时出错", error);
      }

      window.initAliyunCaptcha({
        captchaLogoImg: base64Img,
        SceneId: SCENEID, // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        prefix: PREFIX, // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
        mode: "popup", // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
        element: "#captcha-element", // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        button: "#captcha-button", // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
        captchaVerifyCallback: this.captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
        getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
        slideStyle: {
          width: 320,
          height: 40,
        }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
        language: "cn", // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
      });
    },
    getInstance(instance) {
      this.captcha = instance;
    },
    async captchaVerifyCallback(captchaVerifyParam) {
      try {
        let data = {
          loginname: this.phone,
          captchaVerifyParam: captchaVerifyParam,
          passport: "",
        };
        let res = await getVerificationCode(data);
        console.log("res", res);
        if (res.retuCode == 5000) {
          this.getSms();
          try {
            this.$toast('验证码发送成功~~~');
          } catch (error) {
          }
          return {
            captchaResult: true,
            bizResult: true,
          };
        } else {
          this.$refs.toast.showToast("验证码发送失败~~~");
          return {
            captchaResult: true,
            bizResult: true,
          };
        }
        if (res.status.code == 0) {
          if (res.data.rCode == 1) {
            this.getCode();
            return {
              captchaResult: true,
              bizResult: true,
            };
          } else {
            let errorMsg = {
              230: "验证码无效或已过期，请重新输入",
              211: "手机号无效",
              210: "已达到使用上限,24小时后再次尝试",
            };
            let text = errorMsg[res.data.rCode] || res.data.rMsg || "未知错误";
            this.$Message({
              offset: 300,
              message: text,
              center: true,
              type: "error",
              customClass: "el-tips",
            });
            //操作过于频繁,请稍后重试 已达到使用上限,24小时后再次尝试
            if (
              res.data.rCode == 240 ||
              res.data.rCode == 210 ||
              res.data.rAddCode == 851
            ) {
              return {
                captchaResult: true,
                bizResult: true,
              };
            }
          }
        }
      } catch (error) {
        console.error("error", error);
      }
      return {
        captchaResult: false,
        bizResult: false,
      };
    },
    loadScript(src, callback) {
      let script = document.createElement("script");
      script.type = "text/javascript";
      script.src = src;
      script.onload = function() {
        if (typeof callback === "function") {
          callback();
        }
      };
      document.head.appendChild(script);
    },
     // 绑定QQ接口
    QQBind(){
      QC.Login.showPopup({
          appId:"101941950",
          redirectURI:"https://mceshi.xzjy365.com/QQLogin",  //登录成功后会自动跳往该地址
      });
      // QC.Login.showPopup({
      //   appId:"101941950",
      //   redirectURI:"https://mceshi.xzjy365.com/index"  //登录成功后会自动跳往该地址
      // });
      // window.location.href=`https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=${this.QQLogin.appid}&redirect_uri=https://mceshi.xzjy365.com&state=QQ&scope=get_user_info&display=mobile`
    },
    // 登录
    loginXZ(){
      let _this = this
      let query = this.$route.query
      if(this.areaCode == 86 && this.phone.length != 11){
        this.$refs.toast.showToast("请输入正确的手机号！");
        this.$refs.phone.focus()   // 获取输入手机号的焦点
        return false
      }
      if(this.loginType != 'sms'){
        if(!pwdReg.test(this.password)){
          this.$refs.toast.showToast("请输入正确的密码");
          this.$refs.password.focus()   // 获取输入密码的焦点
          return false
        }
        let params = {
          loginname: this.phone, //登录手机号
          pwd: this.password, //登录密码
          belongUid:query.uid == undefined ? null : query.uid,
          belongGroupId:query.belongGroupId == undefined ? null : query.belongGroupId,
          areaCode:this.areaCode
        };
        loginPwd(params).then((data) => {
          if(data.retuCode == 5021) {
            this.$store.commit("Login/editLoginDialog",false)
            _this.$dialog.alert({
                message: '账号在别处登录,请使用验证码登录',
              }).then(() => {
                this.$store.commit("Login/editLoginDialog",true)
                _this.loginType = 'sms'
                this.phone = params.loginname
              })
            return
          }
          _this.detectBind(data)  // 检测是否绑定了QQ或者微信
          CacheModule.set("loginPhone", data.data.loginname);
          CacheModule.set("setToken", data.data.loginname);
          mutations.getToken(data.data.token);
          this.$store.commit("Login/editIsUser",true)
          this.$store.commit("Login/editLoginDialog",false)
          //999
        }).catch((error) => {
          this.$refs.toast.showToast(error.message);
        });
      }else{
        if(this.codeNumber == ''){
          this.$refs.toast.showToast('请输入验证码');
          this.$refs.codeNumber.focus()
          return false
        }
        let params = {
          loginname: this.phone, //登录手机号
          code: this.codeNumber, //登录验证码
          belongUid:query.uid == undefined ? null : query.uid,
          belongGroupId:query.belongGroupId == undefined ? null : query.belongGroupId,
          areaCode:this.areaCode
        };

        if(window.location.pathname.indexOf('appLogin') > -1){
          params.fromApp = 1
        }

        loginCode(params).then(data => {
          console.log(9999,'data',data)
          _this.detectBind(data)
          CacheModule.set('loginPhone', data.data.loginname)
          CacheModule.set('setToken', data.data.loginname)
          mutations.getToken(data.data.token)
          this.$store.commit("Login/editIsUser",true)
          this.$store.commit("Login/editLoginDialog",false)
        }).catch(error => {
          this.$toast(error.message)
          if(error.message == '验证码有误'){
            this.codeErr = true
          }
        })
      }
      // this.closeLogin()
    },
    // 检测是否绑定了微信和QQ
    detectBind(data){
      console.log(data.data.code)
      localStorage.setItem('code',data.data.code)
      this.$store.commit("Login/editPersonalInfo",data.data)
      localStorage.setItem("userInfo",JSON.stringify(data.data))
      let headimgurl = data.data.headimgurl
      if(headimgurl != null && headimgurl != ''){
        localStorage.setItem("headimgurl",headimgurl)
      }
      localStorage.setItem("uid",data.data.uid)
      if(data.data.qqOpenid != null){
        this.$store.commit("Login/editQqBingType",true)
        localStorage.setItem("qqOpenidType",data.data.qqOpenid)
      }
      if(data.data.wxOpenid != null){
        this.$store.commit("Login/editWxBingType",true)
        localStorage.setItem("wxOpenidType",data.data.wxOpenid)
      }
      if(sessionStorage.getItem('isAapp')) return
      location.reload()
    },
    // 切换登录
    switchLogin(type){
      if(type == 3){
        this.loginType = 'forgetPWd'
      }else if(type == 2){
        this.loginType = 'password'
      }else if(this.loginType == 'sms'){
        this.loginType = 'password'
      }else{
        this.loginType = 'sms'
      }
    },
    getSmsClick() {
      if(this.areaCode == 86) {
        if(this.phone == '' || this.phone.length != 11){
          this.$refs.toast.showToast("请输入正确的手机号~~~");
          this.$refs.phone.focus()   // 获取输入手机号的焦点
          return false
        }
      }
      document.getElementById("captcha-button").click(); //手动隐藏验证框
    },
    // 获取短信
    getSms() {
       if (this.wait == 0) {
        this.wait = 60;
        this.ifCodeNumber = true
        return;
      }else if(this.wait == 60){
        this.wait--;
        setTimeout(() => {
          this.getSms();
        }, 1000);
      } else {
        this.ifCodeNumber = false
        this.wait--;
        setTimeout(() => {
          this.getSms();
        }, 1000);
        return false;
      }
     
      // if(this.ifCodeNumber) {
      //   getVerificationCode({ loginname: this.phone,areaCode:this.areaCode })
      //   .then((data) => {
      //     console.log("验证码", data);
      //   })
      //   .catch((err) => {
      //     alert(err.message)
      //     return false
      //   });
      // }
     
    },
    // 清空信息
    closeLogin(){
      this.codeErr = false
      this.phone = ''
      this.password = ''
      this.codeNumber = ''
      // this.wait = 60
      // this.ifCodeNumber = true
    },
    // 关闭登录框
    close(){
      let path = this.$route.path
      if(path == "/classPay"){
        alert("请先登录")
        return false
      }
      this.$store.commit("Login/editLoginDialog",false) 
    }
  },
  computed:{
    // 监听登录对话框是否关闭
    loginDialog(){
      return this.$store.state.Login.loginDialog
    }
  },
  watch:{
    loginDialog:{
      deep:true,
      immediate:true,
      handler(val){
        if(!val){
          this.closeLogin()
        }
      }
    }
  }
};
</script>

<style scoped>
.intl-tel-input-container >>> .flag-list-box {
  background: white;
  left: -85px;
}
</style>
<style>
#aliyunCaptcha-window-popup {
  width: auto;
}
.aliyunCaptcha-checkbox-body {
  width: 100%;
}
.aliyunCaptcha-checkbox-logo {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
}
</style>
<style lang="less" scoped>

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.password {
  background: #f2f2f2;
  border-radius: 1.3rem;
  .passwordIcon {
    width: 0.8rem !important;
    height: 0.8rem !important;
    margin-left: 0.3rem;
    margin-right: 0.1rem;
    .van-icon__image {
      width: 0.8rem !important;
      height: 0.8rem !important;
    }
  }
}
.phone {
  background: #f2f2f2;
  border-radius: 1.3rem;
  .phoneIcon {
    width: 0.8rem !important;
    height: 0.8rem !important;
    margin-left: 0.3rem;
    margin-right: 0.1rem;
    .van-icon__image {
      width: 0.8rem !important;
      height: 0.8rem !important;
    }
  }
}
.block {
  width: 14.5rem;
  // height: 120px;
  background-color: #fff;
  padding: 0.5rem 0.5rem 1.1rem 1rem;
  border-radius: 0.3rem;
}
.title {
  font-size: 1rem;
  font-weight: 500;
  color: #292e35;
  span {
    font-size: 0.5rem;
    color: #73787f;
  }
}
</style>
